import { Injectable } from "@angular/core"; 
import { HttpClient } from "@angular/common/http";

import { ConfigService } from "./config.service";

@Injectable()
export class ViewerService {


  constructor(    
    private httpsClient: HttpClient, 
    private configService: ConfigService) { 
    
  } 

  getDocument(documentId: string) {
    return this.httpsClient.get<any>(
      `${this.configService.apiUrl}api/v${
        this.configService.apiVersion
      }/documents/policy/${documentId}` 
    );

    // return this.httpsClient.get(
    //   `${this.configService.apiUrl}api/v${
    //     this.configService.apiVersion
    //   }/documents/policy/${documentId}`, { responseType: 'blob' })
    //   .pipe(
    //       map((result: any) => {
    //           return result;
    //       })
    //   );
  }

 
 

}
